"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
class NewsletterManager {
    submitSubscription(item) {
        var _a;
        window.dataLayer.push({
            event: 'trackNyhedsbrev',
            nyhedsbrevhandling: item.subscribed ? 'nyhedsbrev tilmeldt' : 'nyhedsbrev afmeldt',
            nyhedsbrevnavn: (_a = item.title) !== null && _a !== void 0 ? _a : helpers_1.empty,
        });
    }
}
exports.default = NewsletterManager;
